import { Box, Button, Modal, Paper } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import {
  resetSessionExpired,
  selectSessionExpired,
} from "../../slices/session";

const SessionExpiredModal = () => {
  const dispatch = useAppDispatch();
  const labels = useAppSelector(selectLabels);
  const sessionExpired = useAppSelector(selectSessionExpired);

  const handleClose = () => {
    dispatch(resetSessionExpired());
  };

  return (
    <Modal open={sessionExpired} onClose={handleClose}>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 400,
            minWidth: 320,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>{labels.token_expired}</p>
          <div className="w-100 flex gap-4 mt-10">
            <Button variant="contained" fullWidth onClick={handleClose}>
              {labels.accept}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default SessionExpiredModal;
